<template>
  <div class="shadow-none">
    <div>
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <locationHeader
          :hasPermission="hasPermission"
          :activeTabProp="activeSubTab"
          @switchTab="switchSubTab"
          :viewAdd="viewAdd"
          :viewFilter="viewFilter"
        />

        <div v-if="activeSubTab == 'storage'">
          <locationTable
            :SubLocations="SubLocations"
            :hasPermission="hasPermission"
            :Locations="Locations"
            :loading="loading"
            :viewEdit="viewEdit"
            :confirmDelete="confirmDelete"
          />
          <Pagination
            :limit="pageSize"
            :count="pageCount"
            :page="page"
            :itemsCount="count"
            @changePage="gotoPage"
            @changeLimit="changeLimit"
          />
        </div>
        <div v-if="activeSubTab == 'ware'">
          <wareHouse />
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-add" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Create new storage area
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Name</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v1.name }]"
                  type="text"
                  placeholder="Enter name of storage area"
                  v-model="createSubLocation.name"
                />
                <ul v-if="v1.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Warehouse</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="createSubLocation.locationId"
                >
                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
                <ul v-if="v1.locationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Storage Manager</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  :disabled="isBusy || isSameManager"
                  v-model="createSubLocation.managerId"
                >
                  <option
                    v-for="p in warehouseManagers"
                    :key="p.id"
                    :value="p.id"
                  >
                    {{ p.displayName }}
                  </option>
                </select>
                <div class="col-12 col-sm-8 col-lg-10 p-0" v-if="checkManager">
                  <label
                    class="custom-control custom-checkbox custom-control-inline d-flex align-items-center"
                  >
                    <input
                      class="custom-control-input"
                      type="checkbox"
                      @change="sameManagerActive($event)"
                    />
                    <span class="custom-control-label"
                      >Same As Warehouse Manager</span
                    >
                  </label>
                </div>
              </div>
            </div>
            <div class="pb-[10px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Code</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Enter storage code"
                  v-model="createSubLocation.code"
                />
              </div>
            </div>
            <div
              class="flex items-center gap-[10px] max-w-max"
              @click="createSubLocation.active = !createSubLocation.active"
            >
              <button
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
                role="switch"
                :aria-checked="createSubLocation.active"
                :class="{
                  'bg-[#2463eb]': createSubLocation.active,
                  'bg-[#E4E4E7]': !createSubLocation.active,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': createSubLocation.active,
                    'translate-x-0 bg-gray-400': !createSubLocation.active,
                  }"
                ></span>
              </button>
              <span class="cursor-pointer">
                <span
                  class="text-[#353535] text-[16px] font-normal leading-[20px]"
                >
                  This item is active
                </span>
              </span>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[32px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="create"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Add storage area</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-edit" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Edit storage area
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Warehouse</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="updateSubLocation.locationId"
                >
                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
                <ul v-if="v2.locationId" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Storage Manager</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  :disabled="
                    isBusy || isSameManager || updateSubLocation.isChecked
                  "
                  v-model="updateSubLocation.managerId"
                >
                  <option
                    v-for="p in warehouseManagers"
                    :key="p.id"
                    :value="p.id"
                  >
                    {{ p.displayName }}
                  </option>
                </select>
                <div
                  class="col-12 col-sm-8 col-lg-10 p-0"
                  v-if="checkUpdateManager"
                >
                  <label
                    class="custom-control custom-checkbox custom-control-inline d-flex align-items-center"
                  >
                    <input
                      class="custom-control-input"
                      type="checkbox"
                      v-model="updateSubLocation.isChecked"
                      @change="sameUpdateManagerActive($event)"
                    />
                    <span class="custom-control-label"
                      >Same As Warehouse Manager</span
                    >
                  </label>
                </div>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Code</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  v-model="updateSubLocation.code"
                />
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Name</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  :class="[{ 'is-invalid': v2.name }]"
                  type="text"
                  v-model="updateSubLocation.name"
                />
                <ul v-if="v2.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div
              class="flex items-center gap-[10px] max-w-max"
              @click="updateSubLocation.active = !updateSubLocation.active"
            >
              <button
                type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer w-11 focus:outline-none"
                role="switch"
                :aria-checked="updateSubLocation.active"
                :class="{
                  'bg-[#2463eb]': updateSubLocation.active,
                  'bg-[#E4E4E7]': !updateSubLocation.active,
                }"
              >
                <span
                  aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform bg-gray-400 rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': updateSubLocation.active,
                    'translate-x-0 bg-gray-400': !updateSubLocation.active,
                  }"
                ></span>
              </button>
              <span class="cursor-pointer">
                <span
                  class="text-[#353535] text-[16px] font-normal leading-[20px]"
                >
                  This item is active
                </span>
              </span>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[32px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
              @click="cancel"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="update"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-filter" role="dialog">
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#f8f8f8] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="m-0 p-0">
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Warehouse</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.locationId"
                >
                  <option value="0">All Warehouses</option>
                  <option
                    v-for="loc in Locations"
                    :key="loc.id"
                    :value="loc.id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Status</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.status"
                >
                  <option value="0">All Storage areas</option>
                  <option value="True">Active</option>
                  <option value="False">Disabled</option>
                </select>
              </div>
            </div>

            <div>
              <label
                class="text-[#353535] font-medium text-[14px] leading-[20px]"
                >Other filters</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Filter by code or name..."
                  v-model="filter.qry"
                />
              </div>
              <div>
                <div class="mt-[5px]">
                  <label
                    class="custom-control custom-checkbox custom-control-inline"
                  >
                    <input
                      class="custom-control-input"
                      type="checkbox"
                      v-model="filter.showForMe"
                    />
                    <span class="custom-control-label"
                      >My Storage Areas Only</span
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[32px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click="getSubLocations"
            >
              {{ isBusy ? "Loading..." : "Search" }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <GeneralDeleteCaution
      :id="DeleteId"
      @proceed="deleteStorageArea"
      :isBusy="isBusyModal"
      text="storage area"
    />
    <GeneralDeleteMessage
      message="You cannot delete this storage area because there is an inventory 
      or reconcile order transaction history associated with it."
    />
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import GeneralDeleteCaution from "../components/GeneralDeleteCaution.vue";
import GeneralDeleteMessage from "../components/GeneralDeleteMessage.vue";
import Pagination from "../components/Pagination.vue";
import SystemPermissions from "@/permissions";
import locationHeader from "../components/Inventory/locationHeader.vue";
import locationTable from "../components/Inventory/locationTable.vue";
import wareHouse from "../components/Inventory/wareHouse.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsSubLocations",

  components: {
    Select2,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
    Pagination,
    locationHeader,
    locationTable,
    wareHouse,
  },

  created() {
    this.getSubLocations();
    this.getLocations();
    this.getWarehouseManagers();

    if (!this.hasPermission("Inventory_SubLocation_View")) {
      this.$router.push("/restricted");
    }
    if (this.hasPermission("Inventory_SubLocation_View")) {
      this.activeSubTab = "storage";
    } else if (this.hasPermission("Sales_Team_Mapping_View")) {
      this.activeSubTab = "ware";
    } else {
      this.activeSubTab = null;
    }
  },

  watch: {},

  data() {
    return {
      filter: {
        status: "0",
        locationId: "0",
        qry: "",
        showForMe: false,
      },
      isSameManager: false,
      activeSubTab: null,
      isBusy: false,
      warehouseManagers: [],
      isBusyModal: false,
      locationManagerId: "",

      createSubLocation: {
        code: "",
        name: "",
        active: "",
        locationId: "",
        managerId: "",
      },

      updateSubLocation: {
        code: "",
        name: "",
        active: true,
        id: "",
        locationId: "",
        isChecked: false,
        managerId: "",
      },

      editSubLocation: {
        code: "",
        name: "",
        active: true,
        id: "",
        locationId: "",
        managerId: "",
      },

      v1: {
        name: false,
        locationId: false,
      },

      v2: {
        name: false,
        locationId: false,
      },

      SubLocations: [],
      Locations: [],
      DeleteId: "",
      count: 0,
      page: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,
      loading: false,
    };
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    checkManager() {
      if (this.createSubLocation.locationId) {
        const filterManager = this.Locations.find(
          (el) => el.id === this.createSubLocation.locationId
        );
        this.locationManagerId = filterManager.managerId;
        return filterManager.managerId;
      }
    },
    checkUpdateManager() {
      if (this.updateSubLocation.locationId) {
        const filterManager = this.Locations.find(
          (el) => el.id === this.updateSubLocation.locationId
        );
        this.locationManagerId = filterManager.managerId;
        return filterManager.managerId;
      }
    },
  },

  methods: {
    reset() {
      this.page = 1;
      this.filter = {
        status: "0",
        locationId: "0",
        qry: "",
        showForMe: false,
      };
    },
    switchSubTab(subTab) {
      this.activeSubTab = subTab;
    },
    confirmDelete(id) {
      this.DeleteId = id;
      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },

    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },
    async deleteStorageArea() {
      this.isBusyModal = true;
      try {
        const res = await this.$http.delete(
          `/SubLocations/delete/${this.DeleteId}`
        );
        if (res.ok) {
          this.$toast.success("Storage area deleted successfully", {
            icon: true,
            rtl: false,
          });
          this.getSubLocations();
          this.cancelConfirm();
        }
      } catch (error) {
        this.cancelConfirm();
        this.showDeleteMsg();
      }
      this.isBusyModal = false;
    },

    sameManagerActive(e) {
      if (e.target.checked) {
        this.isSameManager = true;
        this.createSubLocation.managerId = this.locationManagerId;
      } else {
        this.isSameManager = false;
      }
    },

    sameUpdateManagerActive(e) {
      if (e.target.checked) {
        this.isSameManager = true;
        this.updateSubLocation.managerId = this.locationManagerId;
      } else {
        this.isSameManager = false;
      }
    },
    async getWarehouseManagers() {
      this.isBusy = true;

      await this.$http
        .get("/Users/getWarehouseManager/")
        .then(function(res) {
          this.warehouseManagers = res.body;
          this.isBusy = false;
        })
        .catch(function() {});
      this.isBusy = false;
    },

    cancel() {
      const currentSubLocation = this.SubLocations.find(
        (l) => l.id === this.editSubLocation.id
      );
      currentSubLocation.name = this.editSubLocation.name;
      currentSubLocation.code = this.editSubLocation.code;
      currentSubLocation.managerId = this.editSubLocation.managerId;
      currentSubLocation.active = this.editSubLocation.active;
      currentSubLocation.id = this.editSubLocation.id;
      currentSubLocation.locationId = this.editSubLocation.locationId;
      this.isSameManager = false;
      // this.locationManagerId = "";
      $("#mod-edit").modal("hide");
    },
    viewExport() {
      //   $("#mod-export").modal("show");
    },
    viewAdd() {
      this.createSubLocation = {
        code: "",
        name: "",
        active: false,
        locationId: "",
        managerId: "",
      };
      this.v1 = {
        name: false,
        locationId: false,
      };
      $("#mod-add").modal("show");
    },
    viewEdit(c) {
      var editValues = {
        code: c.code,
        name: c.name,
        active: c.active,
        id: c.id,
        locationId: c.locationId,
        managerId: c.managerId,
      };
      this.editSubLocation = editValues;
      this.updateSubLocation = c;
      $("#mod-edit").modal("show");
    },
    viewFilter() {
      this.page = 1;
      $("#mod-filter").modal("show");
    },
    async create() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        code: this.createSubLocation.code,
        name: this.createSubLocation.name,
        active: this.createSubLocation.active,
        parentId: this.user.parentId,
        locationId: this.createSubLocation.locationId,
        managerId: this.createSubLocation.managerId,
      };

      if (this.validateCreate()) {
        await this.$http
          .post("/SubLocations/create", data)
          .then(function(res) {
            this.isBusyModal = false;
          })
          .catch(function() {});
        $("#mod-add").modal("hide");

        this.getSubLocations();
      }
      this.isSameManager = false;
      this.createSubLocation.managerId = "";
      this.isBusy = false;
      this.isBusyModal = false;
    },
    validateCreate() {
      this.v1 = {
        name: false,
        locationId: false,
      };
      var isValid = true;

      if (!this.createSubLocation.name) {
        this.v1.name = true;
        isValid = false;
      }

      if (!this.createSubLocation.locationId) {
        this.v1.categoryId = true;
        isValid = false;
      }

      return isValid;
    },
    async update() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        code: this.updateSubLocation.code,
        name: this.updateSubLocation.name,
        active: this.updateSubLocation.active,
        id: this.updateSubLocation.id,
        locationId: this.updateSubLocation.locationId,
        parentId: this.user.parentId,
        managerId: this.updateSubLocation.managerId,
      };

      if (this.validateUpdate()) {
        $("#mod-edit").modal("hide");

        await this.$http
          .put("/SubLocations/update/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
          })
          .catch(function() {});

        this.getSubLocations();
      }
      this.isSameManager = false;
      this.updateSubLocation.managerId = "";
      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateUpdate() {
      this.v2 = {
        name: false,
        locationId: false,
      };

      var isValid = true;

      if (!this.updateSubLocation.name) {
        this.v2.name = true;
        isValid = false;
      }

      if (!this.updateSubLocation.locationId) {
        this.v2.locationId = true;
        isValid = false;
      }

      return isValid;
    },

    async getSubLocations() {
      this.isBusy = true;
      if (this.filter.qry) {
        this.page = 1;
      }
      this.loading = true;
      await this.$http
        .get(
          "/SubLocations/getList?page=" +
            (this.page - 1) +
            "&pageSize=" +
            this.pageSize +
            (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
            (this.filter.locationId != "0"
              ? "&locationId=" + this.filter.locationId
              : "") +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
            (this.filter.showForMe != ""
              ? "&showForMe=" + this.filter.showForMe
              : "")
        )
        .then(function(res) {
          this.SubLocations = res.body.data;
          this.page = res.body.page + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },
    getLocations() {
      var t = "Location";
      var a = true;

      this.$http
        .get(
          "/Locations/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId
        )
        .then(function(res) {
          this.Locations = res.body;
        })
        .catch(function() {});
    },
    formatDate(date) {
      return moment(date).format("lll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    prev() {
      this.page -= 1;
      this.getSubLocations();
    },
    next() {
      this.page += 1;
      this.getSubLocations();
    },

    gotoPage(page) {
      this.page = page;
      this.getSubLocations();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getSubLocations();
    },
  },
};
</script>
